module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANAQMAAABIJXY/AAAABlBMVEX///+3t7drUiW7AAAAAXRSTlMAQObYZgAAAB9JREFUeJxjYEAFTAwM7AwM/A0M8gcY7B8w1H+ACAMAK08EBjNhmlYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-desc.png
// module id = 2227
// module chunks = 0